import anger_smily from '../../assets/img/icons/feedback_01.svg'
import sad_smily from '../../assets/img/icons/feedback_02.svg'
import smily from '../../assets/img/icons/feedback_03.svg'
import laugh_smily from '../../assets/img/icons/feedback_04.svg'
import heart_smily from '../../assets/img/icons/feedback_05.svg'




const FeedBackModal = () => {
    return (
        <div class="modal fade" id="feedbackModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered ">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">FEEDBACK</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body pt-0 pb-0">
                        <div class="px-2 feedbackContent">
                            <p>Share the feedback to receive 500 Mudras!</p>
                            <div class="feedbackSmiley mt-4 mb-3">
                                <ul>
                                    <li><label class="smileyWrap"><input type="radio" name="feedback" /><span><img
                                        src={anger_smily} alt="#" /></span></label></li>
                                    <li><label class="smileyWrap"><input type="radio" name="feedback" /><span><img
                                        src={sad_smily} alt="#" /></span></label></li>
                                    <li><label class="smileyWrap"><input type="radio" name="feedback" /><span><img
                                        src={smily} alt="#" /></span></label></li>
                                    <li><label class="smileyWrap"><input type="radio" name="feedback" /><span><img
                                        src={laugh_smily} alt="#" /></span></label></li>
                                    <li><label class='smileyWrap'><input type="radio" name="feedback" /><span><img
                                        src={heart_smily} alt="#" /></span></label></li>
                                </ul>
                            </div>
                            <div>
                                <label class="labelForm">Tell us how we can improve our registration process?</label>
                                <div>
                                    <textarea class="fieldForm" placeholder="Please mention..."></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button data-bs-dismiss="modal" class="button button-primary w-50" data-bs-toggle="modal"
                            data-bs-target="#congratsModal">Submit</button>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default FeedBackModal